import { Component, Input } from "@angular/core";
import { AppService } from "src/app/app.service";
import { Router } from "@angular/router";
import {
  VAIconRegistryService,
  chartLine,
  infoCircle,
  chevronRight,
} from "@va/core-library/icons";
import { IndustryAnalysisNavigationPopover } from "./comparative-analysis-popover.model";

@Component({
  selector: "app-comparative-analysis-popover-content",
  templateUrl: "./comparative-analysis-popover-content.component.html",
  styleUrls: ["./comparative-analysis-popover-content.component.scss"],
})
export class ComparativeAnalysisPopoverContentComponent {
  industryData: IndustryAnalysisNavigationPopover;
  @Input() comparativeAnalysisPopoverData;
  @Input() ticker: string;
  watchlistData;
  customData;
  compTabCols: any;
  compTabIds: Array<string>;
  compTabDetails: Array<any> = [];
  trendTabDetails: Array<any> = [];
  systemTabDetails: Array<any> = [];
  tabListUnmodified: Array<any> = [];
  tabListUnmodifiedForCustom: Array<any> = [];
  compTabName: string;
  compTabDescription: string;
  trendMappingDetail: any = {};
  systemMappingDetail: any = {};
  comparativeAnalysisList = [
    {
      tab_tag: "industry-peers",
      tab_name: "Industry Peers",
      show_tab: false,
    },
    {
      tab_tag: "comp-tables",
      tab_name: "Comp Tables",
      show_tab: false,
    },
    {
      tab_tag: "custom-analysis",
      tab_name: "Custom Analysis",
      show_tab: false,
    },
    {
      tab_tag: "watchlists",
      tab_name: "Watchlists",
      show_tab: false,
    },
  ];
  columnSortState: { [key: string]: "ascend" | "descend" | null } = {};
  columnSortStateForCustom: { [key: string]: "ascend" | "descend" | null } = {};
  colKeyStylesMapping = {
    topic: {
      width: "100px",
    },
    geography: {
      width: "105px",
    },
    subtopic: {
      width: "200px",
    },
    name: {
      width: "250px",
    },
  };

  colKeyStylesMappingForCustom = {
    topic: {
      width: "220px",
    },
  };

  activeTab: string = "industry-peers";

  constructor(
    private appService: AppService,
    public router: Router,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([chartLine, infoCircle, chevronRight]);
  }

  ngOnInit() {
    if (this.comparativeAnalysisPopoverData) {
      if (
        this.comparativeAnalysisPopoverData.industry &&
        this.comparativeAnalysisPopoverData.industry.data
      ) {
        this.industryData = this.comparativeAnalysisPopoverData.industry.data;
      }
      if (
        this.comparativeAnalysisPopoverData.comp_tables &&
        this.comparativeAnalysisPopoverData.comp_tables.length
      )
        this.processCompTableData(
          this.comparativeAnalysisPopoverData.comp_tables,
        );
      if (this.comparativeAnalysisPopoverData.custom_table)
        this.processCustomAnalysisTableData(
          this.comparativeAnalysisPopoverData.custom_table,
        );
      if (
        this.comparativeAnalysisPopoverData.watchlist &&
        this.comparativeAnalysisPopoverData.watchlist.data &&
        this.comparativeAnalysisPopoverData.watchlist.data.length
      )
        this.watchlistData = this.comparativeAnalysisPopoverData.watchlist.data;

      this.comparativeAnalysisList = [
        {
          ...this.comparativeAnalysisList[0],
          show_tab:
            this.industryData &&
            this.industryData.columns &&
            this.industryData.columns.length > 0
              ? true
              : false,
        },
        {
          ...this.comparativeAnalysisList[1],
          show_tab:
            this.compTabDetails && this.compTabDetails.length > 0
              ? true
              : false,
        },
        {
          ...this.comparativeAnalysisList[2],
          show_tab: this.customData ? true : false,
        },
        {
          ...this.comparativeAnalysisList[3],
          show_tab: this.watchlistData ? true : false,
        },
      ];
      this.activeTab =
        this.industryData &&
        this.industryData.columns &&
        this.industryData.columns.length > 0
          ? "industry-peers"
          : this.compTabDetails && this.compTabDetails.length > 0
            ? "comp-tables"
            : this.customData
              ? "custom-analysis"
              : this.watchlistData
                ? "watchlists"
                : undefined;
    }
  }

  ngOnChanges() {}

  processCustomAnalysisTableData(customDataResponse) {
    this.customData = customDataResponse;
    this.customData.tab_details.forEach((item) => {
      if (!item.topic && item.topic_id === 1) {
        //Executed only for the first time
        item["link"] = `comparative-analysis/user/${item.link}`;
      } else if (!item.topic && item.topic_id === 2) {
        item["link"] = `charts/${item.link}`;
      }
      item["topic"] = this.customData.mapping[item.topic_id];
    });
    this.tabListUnmodifiedForCustom = [...this.customData.tab_details];
  }

  processCompTableData(compTab) {
    const cols = {
      geography: "Geography",
      topic: "Topic",
      subtopic: "Sub-Topic",
      name: "Name",
    };
    const ids = ["geography", "topic", "subtopic", "name"];
    if (compTab && compTab.length > 0) {
      this.compTabName = compTab[0].tab_name;
      this.compTabCols = cols;
      this.trendMappingDetail = compTab[0].mapping;
      this.systemMappingDetail =
        compTab.length > 1
          ? compTab[1].mapping
          : this.compTabName &&
              !this.compTabName.toLowerCase().includes("trend")
            ? compTab[0].mapping
            : {};
      this.compTabIds = ids;
      this.trendTabDetails =
        this.compTabName && this.compTabName.toLowerCase().includes("trend")
          ? compTab[0].tab_details
          : [];
      this.systemTabDetails =
        compTab.length > 1
          ? compTab[1].tab_details
          : this.compTabName &&
              !this.compTabName.toLowerCase().includes("trend")
            ? compTab[0].tab_details
            : [];
      this.trendTabDetails = this.trendTabDetails.map((detail) => {
        const obj = {};
        for (let i = 0; i < this.compTabIds.length; i++) {
          const colKey = this.compTabIds[i];
          const key = `${colKey}_id`;
          if (colKey !== "name")
            obj[colKey] = detail[key]
              ? this.trendMappingDetail[detail[key]]
              : "\xa0\xa0\xa0\xa0\xa0\xa0\xa0-";
          else obj[colKey] = detail[colKey];
        }
        if (
          this.compTabName &&
          this.compTabName.toLowerCase().includes("trend")
        ) {
          const d = new Date();
          const from = d.getFullYear() - 2;
          const to = d.getFullYear() + 4;
          let compPeriods = "";
          let chartPeriods = "";
          for (let i = from; i <= to; i++) {
            compPeriods += `&period=CY-${i}`;
            chartPeriods += `&periods=CY-${i}`;
          }
          const name = encodeURIComponent(detail["name"]);
          obj["link"] = `comparative-analysis/current?uniquesliids=${detail[
            "line_id"
          ].join("&uniquesliids=")}&tickers=${
            this.ticker
          }&tab_name=${name}${compPeriods}&comp_type=trend&comps_name=${name}`;
          obj["chartLink"] = `charts/current?ticker=${
            this.ticker
          }&lineId=${detail["line_id"].join(
            "&lineId=",
          )}&chartTypeId=2${chartPeriods}`;
          obj["showChart"] = detail["show_charts"];
        }
        if (detail["line_id"]) {
          obj["lineId"] = detail["line_id"];
        }
        return obj;
      });
      this.systemTabDetails = this.systemTabDetails.map((detail) => {
        const obj = {};
        for (let i = 0; i < this.compTabIds.length; i++) {
          const colKey = this.compTabIds[i];
          const key = `${colKey}_id`;
          if (colKey !== "name")
            obj[colKey] = detail[key]
              ? this.systemMappingDetail[detail[key]]
              : "\xa0\xa0\xa0\xa0\xa0\xa0\xa0-";
          else obj[colKey] = detail[colKey];
        }
        if (detail["link"])
          obj["link"] =
            `comparative-analysis/current?comp_type=system&id=${detail["link"]}`;
        if (detail["line_id"]) {
          obj["lineId"] = detail["line_id"];
        }
        return obj;
      });
      this.compTabDetails = [...this.trendTabDetails, ...this.systemTabDetails];
      this.tabListUnmodified = [...this.compTabDetails];
    }
  }

  onSortChangeForCustom = (key: string, value: "ascend" | "descend" | null) => {
    this.columnSortStateForCustom.topic = null;
    this.columnSortStateForCustom.name = null;
    this.columnSortStateForCustom[key] = value;

    if (value === null) {
      this.customData.tab_details = [...this.tabListUnmodifiedForCustom];
      return;
    }

    switch (key) {
      case "topic":
        this.sortByIdForCustom("topic");
        break;
      case "name":
        this.sortByIdForCustom("name");
        break;
      default:
        this.customData.tab_details = [...this.tabListUnmodifiedForCustom];
    }
  };

  sortByIdForCustom = (id) => {
    const isDescend = this.columnSortStateForCustom[id] === "descend";
    id = id === "topic" ? "topic_id" : id;
    let itemHavingData = this.customData.tab_details;
    itemHavingData = this.appService.basicSort(
      itemHavingData,
      [id],
      isDescend,
      (item: string) => {
        if (item) {
          return item.toLowerCase();
        }
        return item;
      },
    );
    this.customData.tab_details = itemHavingData;
  };

  onSortChange = (key: string, value: "ascend" | "descend" | null) => {
    this.columnSortState.topic = null;
    this.columnSortState.name = null;
    this.columnSortState.geography = null;
    this.columnSortState.subtopic = null;
    this.columnSortState[key] = value;

    if (value === null) {
      this.compTabDetails = [...this.tabListUnmodified];
      return;
    }

    switch (key) {
      case "topic":
        this.sortById("topic");
        break;
      case "name":
        this.sortById("name");
        break;
      case "geography":
        this.sortById("geography");
        break;
      case "subtopic":
        this.sortById("subtopic");
        break;
      default:
        this.compTabDetails = [...this.tabListUnmodified];
    }
  };

  sortById = (id) => {
    const isDescend = this.columnSortState[id] === "descend";
    const sortedList = [...this.compTabDetails];
    let itemHavingData = [];
    const itemWithoutData = sortedList.filter((item) => {
      if (item[id]) {
        itemHavingData.push(item);
        return false;
      }
      return item;
    });
    itemHavingData = this.appService.basicSort(
      itemHavingData,
      [id],
      isDescend,
      (item: string) => {
        if (item) {
          return item.toLowerCase();
        }
        return item;
      },
    );
    this.compTabDetails = itemHavingData.concat(itemWithoutData);
  };

  handleComparativeTabChange(tab) {
    this.activeTab = tab;
  }
}
